<template>
    <div class="topbar">
        <div @click="toBookshelves" class="button">
            <icon type="ios-grid" />
        </div>
        <div ref="musicButton" @click="onMusicClick" class="button">
            <Icon v-if="music" type="md-volume-up" />
            <Icon v-else type="md-volume-off" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        music: {
            default: true,
        }
    },
    methods: {
        toBookshelves() {
            this.$router.push({
                path: '/index.html',
            });
        },
        onMusicClick() {
            this.$emit('musicClick', !this.music);
        },
        clickMusic() {
            this.$refs.musicButton.click();
        }
    }
}
</script>

<style lang="less" scoped>
.topbar {
    font-size: 2.5vh;

    .button {
        display: inline-block;
        width: 1.75em;
        height: 1.75em;
        margin: .25em;
        text-align: center;
        color: white;
        border: 1px solid white;
    }
}
</style>
